import { AfterViewInit, Component, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AngularMultiSelect } from 'angular2-multiselect-dropdown';
import { CheckAuth } from 'src/Services/utility.service';
import { CountyMasterService } from 'src/Services/county-master.service';
import { CountyMaster911Model } from 'src/Models/CountyMaster911Model';
import { Router } from '@angular/router';
import { StateMasterService } from 'src/Services/state-master.service';
import { StateMasterModel } from 'src/Models/stateMasterModel';
import { CityMasterService } from 'src/Services/city-master.service';
import { DropDown911Model } from 'src/Models/CityMaster911Model';
import { Main911Service } from 'src/Services/main911.service';
import { Main911Model } from 'src/Models/Main911Model';
import { DatePipe } from '@angular/common';
import { I360Service } from 'src/Services/i360Service';
import { Filter911Model, FilterModel } from 'src/Models/filterModel';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddLocation911Model } from 'src/Models/Location911Model';
import { Location911Service } from 'src/Services/location911.service';
import { Title } from '@angular/platform-browser';
import { of, Subject } from 'rxjs';
import { catchError, debounceTime, map, switchMap, takeUntil } from 'rxjs/operators';
import { SessionStorageService } from 'src/common/session-storage.service';
@Component({
  selector: 'app-rate-main911',
  templateUrl: './rate-main911.component.html',
  styleUrls: ['./rate-main911.component.css']
})
export class RateMain911Component implements OnInit, AfterViewInit, OnDestroy {
  tokenKey: string;
  listofMain911: Main911Model[];
  PageNumber: number = 1;
  PageSize: number = 10;
  isRecord: boolean = false;
  isloading: boolean = false;
  totalRecordCount: number = 0;
  stateId: string = '';
  filterText: string = '';
  SelectedTool: string;
  stateList: StateMasterModel[] = [];
  countyId: string = '';
  countyList: CountyMaster911Model[] = [];
  selectedCounty :any = [];
  orderBy: string = 'EndDate Desc';
  isAscending: boolean = false;
  upDowNameCSS: string = '';
  upDowScopeNameCSS: string = '';
  upDowRateNameCSS: string = '';
  upDowFeeCSS: string = '';
  upDowEffectiveDateCSS: string = '';
  upDowEndDateCSS: string = '';
  upDowAuditDateCSS: string = '';
  upDowAuditMonthCSS: string = '';
  upDowWhatTaxedCSS: string = '';
  upDowNotesCSS: string = '';
  upDowActiveCSS: string = '';

  dropdownListState :any = [];
  selectedItemsState :any = [];
  dropdownSettingsState = {};
  listOfStateIds :any = [];
  selectedItemsConuty:any = [];
  selectedItemsCounty:any = [];
  dropdownSettingsDateFilter = {};
  listOfCountyIds:any = [];
  cityId: string = '';
  selectedState :any = [];
  dropdownDateCountyFilter:any = [];
  selectedCity :any = [];
  cityList: DropDown911Model[] = [];
  dropdownDateCityFilter:any = [];
  todayDate: any;
  filterModel = new FilterModel();
  blockedDocument = false;
  isShowprogressSpinner = false;
  dropdownSettingsDateCountyFilter = {};
  dropdownSettingsDateCityFilter = {};
  stateIds: string = '';
  countyIds: string = '';
  cityIds: string = '';
  listOfCityIds:any = [];
  listofMain911PrintData: any[] = [];
  filter911Model = new Filter911Model();
  module = '911';
  isInActiveRate: boolean;
  dropdownSettingsCountyFilter = {};
  dropdownSettingsCityFilter = {};
  dropdownSettingsEditStateFilter = {};
  isSubmit: boolean = false;
  rateId: number = 0;
  @ViewChild('fileInput', { static: true }) fileInput;
  @ViewChild('cityFilterDropdown', { static: false }) cityFilterDropdown: AngularMultiSelect;
  exportDoc: any;
  duplicateRateId: number = 0;
  deleteRateId = 0;
  openMenuIndex: number = -1;
  dropdownSettingsStatus = {};
  selectedItemsStatus :any = [];
  listOfStatus :any = [];
  statusId: string = '';
  moduleList: any[] = [{ itemName: 'Yes', id: '1' }, { itemName: 'No', id: '0' }];
  isCountyFilterLoading = false;
  isCityFilterLoading = false;
  isCitySelectionLoading = false;
  private isAllCitiesSelected = false;
  private isApplyingCitySelection = false;
  private cityDropdownPatched = false;
  private citySelectedIdMap: { [id: string]: boolean } = {};
  private readonly cityBadgeLimit = 50;
  private readonly allCitiesPlaceholderId = '__ALL_CITIES__';
  private readonly manyCitiesPlaceholderId = '__MANY_CITIES__';
  private countyLoad$ = new Subject<string>();
  private cityLoad$ = new Subject<string>();
  private destroy$ = new Subject<void>();
  private countyApplySeq = 0;
  private cityApplySeq = 0;
  private citySelectionSeq = 0;

  constructor(private readonly countyService: CountyMasterService, 
    private readonly locationService: Location911Service, 
    private readonly stateService: StateMasterService, 
    private readonly router: Router, 
    private readonly checkAuth: CheckAuth, 
    private readonly cityService: CityMasterService, 
    private readonly main911Service: Main911Service, 
    private readonly datePipe: DatePipe, 
    private readonly i360service: I360Service, 
    private readonly toastr: ToastrService, 
    private readonly modalService: NgbModal,
    private readonly titleService:Title,
    private sessionStorageService: SessionStorageService,
    private readonly ngZone: NgZone
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('911 Rates');
    if (this.router.url == '/admin/911/inactiveRates') this.isInActiveRate = true;
    else this.isInActiveRate = false;

  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.todayDate = this.datePipe.transform(new Date(), 'MM-dd-yyyy');
    this.dropdownSettingsDateFilter = {
      singleSelection: false,
      text: "Filter by Jurisdiction",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Jurisdiction(s) available',
      showCheckbox: true
    };
    this.dropdownSettingsDateCountyFilter = {
      singleSelection: false,
      text: "Filter by County",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No County(s) available',
      showCheckbox: true,
      lazyLoading: true
    };
    this.dropdownSettingsDateCityFilter = {
      singleSelection: false,
      text: "Filter by City",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No City(s) available',
      showCheckbox: true,
      lazyLoading: true,
      enableCheckAll: true,
      enableFilterSelectAll: true,
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All"
    };
    this.dropdownSettingsEditStateFilter = {
      singleSelection: true,
      text: "Select Filter(s)",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 2,
      noDataLabel: 'No Jurisdiction(s) available',
      showCheckbox: false,
      enableFilterSelectAll: false
    };
    this.dropdownSettingsCountyFilter = {
      singleSelection: true,
      text: "Select Filter(s)",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 2,
      noDataLabel: 'No County(s) available',
      showCheckbox: false,
      disabled: false,
      enableFilterSelectAll: false
    };
    this.dropdownSettingsCityFilter = {
      singleSelection: true,
      text: "Select Filter(s)",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 2,
      noDataLabel: 'No City(s) available',
      showCheckbox: false,
      disabled: false,
      enableFilterSelectAll: false
    };
    this.dropdownSettingsStatus = {
      singleSelection: true,
      text: "Filter by Active",
      enableSearchFilter: false,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No record available',
      showCheckbox: false
    };
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.initDependentFilterLoaders();
    this.getState();
    this.MainGetAll();
  }

  ngAfterViewInit() {
    this.patchCityFilterDropdown();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCityFilterOpen() {
    this.patchCityFilterDropdown();
    this.markCitySelectAllChecked();
  }

  private initDependentFilterLoaders() {
    this.countyLoad$.pipe(
      debounceTime(50),
      switchMap(stateId => {
        const requestSeq = this.countyApplySeq;
        return this.countyService.GetCountyByStateId(stateId, true).pipe(
          catchError(() => of(null)),
          map(result => ({ result: result, requestSeq: requestSeq }))
        );
      }),
      takeUntil(this.destroy$)
    ).subscribe(payload => this.applyCountyFilterData(payload.result, payload.requestSeq));

    this.cityLoad$.pipe(
      debounceTime(50),
      switchMap(countyId => {
        const requestSeq = this.cityApplySeq;
        return this.cityService.GetCityByCountyIdMultiple(this.tokenKey, countyId, true).pipe(
          catchError(() => of(null)),
          map(result => ({ result: result, requestSeq: requestSeq }))
        );
      }),
      takeUntil(this.destroy$)
    ).subscribe(payload => this.applyCityFilterData(payload.result, payload.requestSeq));
  }

  keywordFilters($event) {
    if ($event.target.value != "" && $event.target.value != null)
      this.filterText = $event.target.value;
    else
      this.filterText = '';
    this.MainGetAll();
  }

  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.MainGetAll();
  }

  MainGetAll() {
    this.isloading = true;
    this.stateId = "";
    this.countyId = "";
    if (this.listOfCountyIds.length > 0) {
      this.countyId = this.listOfCountyIds.join(',')
    }
    this.cityId = this.getCityFilterValue();
    if ((this.selectedState.length > 0 && !this.isInActiveRate) || this.isInActiveRate) {
      this.stateId = this.listOfStateIds.join(',')
      if (this.isInActiveRate) {
        this.stateId = "";
        this.countyId = "";
        this.cityId = "";
        this.dropdownDateCountyFilter = [];
        this.selectedItemsCounty = [];
        this.listOfCountyIds = [];
        this.selectedState = [];
        this.dropdownDateCityFilter = [];
        this.listOfCityIds = [];
        this.selectedCity = [];
        this.selectedItemsCounty = [];
        this.dropdownDateCityFilter = [];
      }
      this.main911Service.MainGetAll(this.tokenKey, this.PageNumber, this.PageSize, this.stateId, this.countyId, this.cityId, this.orderBy, this.statusId).subscribe(
        data => {
          this.isloading = false;
          this.listofMain911 = data['main'];
          if (this.listofMain911 != null) {
            if (this.listofMain911.length == 0)
              this.isRecord = true;
            else {
              this.isRecord = false;
              this.totalRecordCount = this.listofMain911[0].totalRecordCount;
              this.listofMain911.forEach((x) => {
                if (new Date(this.datePipe.transform(new Date(x.endDate), 'MM-dd-yyyy')) >= new Date(this.todayDate)) x['isActive'] = true;
                else x['isActive'] = false;
              })
            }
          }
          else
            this.isRecord = true;
        },
        error => { }
      );
    }
  }

  setDeleteData(id) {
    this.rateId = id;
  }

  delete911Main(deletedId) {
    this.isloading = true;
    this.main911Service.Delete911Main(this.tokenKey, deletedId).subscribe(
      data => {
        this.MainGetAll();
        this.toastr.success('Rate deleted successfully.', 'Delete')
      },
      error => { }
    );
  }

  getState() {
    this.stateService.GetStateMaster(this.tokenKey, this.module).subscribe(
      data => {
        this.stateList = data['state'];
        this.dropdownListState = [];
        if (this.stateList.length > 0) {
          this.stateList.forEach(x => {
            this.dropdownListState.push({ "id": x.stateId, "itemName": x.name })
          });
        }
      },
      error => { }
    );
  }

  sort(sortBy: string) {
    this.upDowNameCSS = '';
    this.upDowScopeNameCSS = '';
    this.upDowActiveCSS = '';
    this.upDowFeeCSS = '';
    this.upDowEndDateCSS = '';
    this.upDowEffectiveDateCSS = '';
    this.upDowWhatTaxedCSS = '';
    this.upDowNotesCSS = '';
    this.upDowRateNameCSS = '';
    this.upDowAuditDateCSS = '';
    this.upDowAuditMonthCSS = '';
    if (!this.isAscending) {
      this.isAscending = true;
      this.orderBy = sortBy + ' DESC';

      if (sortBy === "TaxName") {
        this.upDowNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "ScopeID") {
        this.upDowScopeNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Rate") {
        this.upDowRateNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Fee") {
        this.upDowFeeCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "EffectiveDate") {
        this.upDowEffectiveDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "EndDate") {
        this.upDowEndDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "WhatTaxed") {
        this.upDowWhatTaxedCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Notes") {
        this.upDowNotesCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "AuditDate") {
        this.upDowAuditDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "AuditMonth") {
        this.upDowAuditMonthCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.orderBy = sortBy;

      if (sortBy === "TaxName") {
        this.upDowNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "ScopeID") {
        this.upDowScopeNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Rate") {
        this.upDowRateNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Fee") {
        this.upDowFeeCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "EffectiveDate") {
        this.upDowEffectiveDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "EndDate") {
        this.upDowEndDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "WhatTaxed") {
        this.upDowWhatTaxedCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Notes") {
        this.upDowNotesCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "AuditDate") {
        this.upDowAuditDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "AuditMonth") {
        this.upDowAuditMonthCSS = 'fa fa-arrow-up';
      }
    }
    this.MainGetAll();
  }

  addRate() {
    let navigation = '/admin/' + this.SelectedTool + '/rates/manage';
    this.router.navigate([navigation]);
  }

  updateRate(rateID) {
    window.open('/#/admin/' + this.SelectedTool + '/rates/manage/' + rateID,"_blank");
  }

  Export911Main() {
    this.isloading = true;
    this.blockedDocument = true;
    this.isShowprogressSpinner = true;
    this.stateId = '';
    this.countyId = '';
    if (this.selectedState.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    if (this.listOfCountyIds.length > 0) {
      this.countyId = this.listOfCountyIds.join(',')
    }
    this.cityId = this.getCityFilterValue();
    this.main911Service.Export911Main(this.tokenKey, this.stateId, this.countyId, this.cityId, this.orderBy,this.statusId).subscribe(
      data => {
        this.blockedDocument = false;
        this.isShowprogressSpinner = false;
        this.isloading = false;
        if (data != null) {

          if (data.status == 'Success') {
            this.filterModel.docPath = data.responseNewFilename;
            this.filterModel.docType = '911Main Exports';
            this.i360service.DownloadDocument(this.tokenKey, this.filterModel).subscribe(
              fileData => {

                if (fileData != null) {
                  FileSaver.saveAs(fileData, '911MainExports.csv');
                }
              }, error => {
                console.log(error);
              }
            );
          }
          else {
            this.toastr.error(data.status, 'Error');
          }
        }
      },
      error => {
        this.blockedDocument = false;
        this.isShowprogressSpinner = false;
        this.isloading = false;
      }
    );
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  onSelectState($event) {
    this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
    this.listOfStateIds.push($event.id);
    this.stateId = '';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.GetCountyByStateId(this.stateId);
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
  }

  onDeSelectState($event) {

    if (this.listOfStateIds != null) {
      if (this.listOfStateIds.length > 0) {
        this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
      }
    }
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    if (this.listOfStateIds.length == 0) {
      this.countyApplySeq++;
      this.cityApplySeq++;
      this.isCountyFilterLoading = false;
      this.isCityFilterLoading = false;
      this.dropdownSettingsDateCountyFilter['noDataLabel'] = 'No County(s) available';
      this.dropdownSettingsDateCityFilter['noDataLabel'] = 'No City(s) available';
      this.dropdownDateCountyFilter = [];
      this.selectedItemsCounty = [];
      this.listOfCountyIds = [];
      this.isAllCitiesSelected = false;
      this.citySelectedIdMap = {};
      this.selectedCity = [];
      this.dropdownDateCityFilter = [];
      this.listOfCityIds = [];
    }
    else{
      this.GetCountyByStateId(this.stateId);
    }
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
  }

  onSelectAll($event) {
    this.listOfStateIds = this.getIdsFromItems($event);
    this.stateId = this.listOfStateIds.join(',');
    this.GetCountyByStateId(this.stateId);
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
  }

  onDeSelectAllState($event) {
    this.countyApplySeq++;
    this.cityApplySeq++;
    this.listOfStateIds = [];
    this.listOfCountyIds = [];
    this.selectedItemsCounty = [];
    this.dropdownDateCountyFilter = [];
    this.listOfCityIds = [];
    this.selectedCity = [];
    this.dropdownDateCityFilter = [];
    this.selectedState = [];
    this.isAllCitiesSelected = false;
    this.citySelectedIdMap = {};
    this.isCountyFilterLoading = false;
    this.isCityFilterLoading = false;
    this.dropdownSettingsDateCountyFilter['noDataLabel'] = 'No County(s) available';
    this.dropdownSettingsDateCityFilter['noDataLabel'] = 'No City(s) available';
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
  }

  onSelectCounty($event) {

    this.listOfCountyIds = this.removeElemetninArray(this.listOfCountyIds, $event.id)
    this.listOfCountyIds.push($event.id);
    this.countyId = '';
    if (this.listOfCountyIds.length > 0) {
      this.countyId = this.listOfCountyIds.join(',')
    }
    this.GetCityByCountyId(this.countyId);
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
  }

  onDeSelectCounty($event) {

    if (this.listOfCountyIds != null) {
      if (this.listOfCountyIds.length > 0) {
        this.listOfCountyIds = this.removeElemetninArray(this.listOfCountyIds, $event.id)
      }
    }
    this.countyId = '';
    if (this.listOfCountyIds.length > 0) {
      this.countyId = this.listOfCountyIds.join(',')
    }
    if (this.listOfCountyIds.length == 0) {
      this.clearCityFilter();
    }
    else
      this.GetCityByCountyId(this.countyId);
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
  }

  onSelectAllCounty($event) {
    this.listOfCountyIds = this.getIdsFromItems($event);
    this.countyId = this.listOfCountyIds.join(',');
    this.GetCityByCountyId(this.countyId);
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
  }

  onDeSelectAllCounty($event) {
    this.listOfCountyIds = [];
    this.clearCityFilter();
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
    else this.selectedItemsConuty = [];
  }


  onSelectCity($event) {
    if (this.isApplyingCitySelection || this.isPlaceholderCityItem($event)) {
      return;
    }
    this.isAllCitiesSelected = false;
    this.listOfCityIds = this.removeElemetninArray(this.listOfCityIds, $event.id)
    this.listOfCityIds.push($event.id);
    this.citySelectedIdMap[$event.id] = true;
    this.selectedCity = this.appendSelectedCityItem($event);
    this.PageNumber = 1;
    this.PageSize = 10;
    this.compactSelectedCityIfNeeded();
    if (!this.isInActiveRate) this.MainGetAll();
  }

  onDeSelectCity($event) {
    if (this.isApplyingCitySelection || this.isPlaceholderCityItem($event)) {
      this.clearCompactCitySelection();
      return;
    }
    this.isAllCitiesSelected = false;
    if (this.listOfCityIds != null) {
      if (this.listOfCityIds.length > 0) {
        this.listOfCityIds = this.removeElemetninArray(this.listOfCityIds, $event.id)
      }
    }
    delete this.citySelectedIdMap[$event.id];
    this.selectedCity = (this.selectedCity || []).filter(item => item && item.id !== $event.id);
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
    else this.selectedCity = [];
  }

  onSelectAllCity($event) {
    this.applyAllCitiesSelection();
  }

  onDeSelectAllCity($event) {
    this.clearCompactCitySelection();
  }

  onChangeState(event) {
    this.dropdownDateCityFilter = [];
    this.dropdownDateCountyFilter = [];
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
    if (event.id) this.GetCountyByStateId(event.id)
  }

  onDeSelectDateFilterAll($event) {
    this.selectedState = [];
    this.selectedCounty = [];
    this.selectedCity = [];
    this.dropdownDateCityFilter = [];
    this.dropdownDateCountyFilter = [];
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
  }

  onDeSelectDateFilterCountyAll($event) {
    this.selectedCounty = [];
    this.selectedCity = [];
    this.dropdownDateCityFilter = [];
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
  }

  onChangeCounty(event) {
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
    if (event.id) this.GetCityByCountyId(event.id)
  }
  onChangeCity(event) {
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
  }
  onDeSelectDateFilterCityAll($event) {
    this.PageNumber = 1;
    this.PageSize = 10;
    this.selectedCity = [];
    if (!this.isInActiveRate) this.MainGetAll();
  }
  GetCountyByStateId(stateId:any) {
    this.countyApplySeq++;
    if (!stateId) {
      this.isCountyFilterLoading = false;
      this.dropdownSettingsDateCountyFilter['noDataLabel'] = 'No County(s) available';
      this.dropdownDateCountyFilter = [];
      this.selectedItemsCounty = [];
      this.listOfCountyIds = [];
      this.clearCityFilter();
      return;
    }
    this.isCountyFilterLoading = true;
    this.dropdownSettingsDateCountyFilter['noDataLabel'] = 'Loading counties...';
    this.countyLoad$.next(String(stateId));
  }

  GetCityByCountyId(countyId) {
    if (!countyId) {
      this.clearCityFilter();
      return;
    }
    this.isAllCitiesSelected = false;
    this.cityApplySeq++;
    this.isCityFilterLoading = true;
    this.dropdownSettingsDateCityFilter['noDataLabel'] = 'Loading cities...';
    this.cityLoad$.next(String(countyId));
  }

  private applyCountyFilterData(result: any, requestSeq: number) {
    if (requestSeq !== this.countyApplySeq) {
      return;
    }
    if (!result || result['status'] != 'Success') {
      this.isCountyFilterLoading = false;
      this.dropdownSettingsDateCountyFilter['noDataLabel'] = 'No County(s) available';
      return;
    }

    const countyList = result['county'] || [];
    const selectedCountyIds = this.listOfCountyIds;

    this.ngZone.runOutsideAngular(() => {
      const selectedIdSet = {};
      for (let i = 0; i < selectedCountyIds.length; i++) {
        selectedIdSet[selectedCountyIds[i]] = true;
      }

      const dropdownItems = new Array(countyList.length);
      const selectedItems = [];
      const keptIds = [];
      for (let i = 0; i < countyList.length; i++) {
        const county = countyList[i];
        const item = { "id": county.countyId, "itemName": county.countyName };
        dropdownItems[i] = item;
        if (selectedIdSet[county.countyId]) {
          selectedItems.push(item);
          keptIds.push(county.countyId);
        }
      }

      setTimeout(() => {
        this.ngZone.run(() => {
          if (requestSeq !== this.countyApplySeq) {
            return;
          }
          this.countyList = countyList;
          this.dropdownDateCountyFilter = dropdownItems;
          this.selectedItemsCounty = selectedItems;
          this.listOfCountyIds = keptIds;
          this.isCountyFilterLoading = false;
          this.dropdownSettingsDateCountyFilter['noDataLabel'] = 'No County(s) available';
          if (this.listOfCountyIds.length > 0) {
            this.countyId = this.listOfCountyIds.join(',');
            this.GetCityByCountyId(this.countyId);
          } else {
            this.clearCityFilter();
          }
        });
      }, 0);
    });
  }

  private applyCityFilterData(result: any, requestSeq: number) {
    if (requestSeq !== this.cityApplySeq) {
      return;
    }
    if (this.listOfCountyIds.length == 0) {
      this.clearCityFilter();
      return;
    }
    if (!result || result['status'] != 'Success') {
      this.isCityFilterLoading = false;
      this.dropdownSettingsDateCityFilter['noDataLabel'] = 'No City(s) available';
      return;
    }

    const cityList = result['city'] || [];
    const selectedCityIds = this.listOfCityIds;
    const keepAllCities = this.isAllCitiesSelected;

    this.ngZone.runOutsideAngular(() => {
      const cityById = {};
      for (let i = 0; i < cityList.length; i++) {
        cityById[cityList[i].id] = cityList[i];
      }

      const keptIds = [];
      const selectedItems = [];
      const selectedIdMap = {};
      if (!keepAllCities) {
        for (let i = 0; i < selectedCityIds.length; i++) {
          const city = cityById[selectedCityIds[i]];
          if (city) {
            keptIds.push(selectedCityIds[i]);
            selectedItems.push(city);
            selectedIdMap[selectedCityIds[i]] = true;
          }
        }
      }

      setTimeout(() => {
        this.ngZone.run(() => {
          if (requestSeq !== this.cityApplySeq) {
            return;
          }
          this.cityList = cityList;
          this.dropdownDateCityFilter = cityList;
          this.isCityFilterLoading = false;
          this.dropdownSettingsDateCityFilter['noDataLabel'] = 'No City(s) available';
          if (keepAllCities && cityList.length > 0) {
            this.applyAllCitiesSelection();
            return;
          }
          this.listOfCityIds = keptIds;
          this.citySelectedIdMap = selectedIdMap;
          this.setSelectedCityDisplay(selectedItems);
        });
      }, 0);
    });
  }

  private clearCityFilter() {
    this.cityApplySeq++;
    this.citySelectionSeq++;
    this.isAllCitiesSelected = false;
    this.isCitySelectionLoading = false;
    this.isCityFilterLoading = false;
    this.citySelectedIdMap = {};
    this.dropdownSettingsDateCityFilter['noDataLabel'] = 'No City(s) available';
    this.listOfCityIds = [];
    this.selectedCity = [];
    this.dropdownDateCityFilter = [];
    this.syncCityDropdownSelection([]);
  }

  private getCityFilterValue(): string {
    if (this.isAllCitiesSelected) {
      return '';
    }
    if (!this.listOfCityIds || this.listOfCityIds.length == 0) {
      return '';
    }
    return this.listOfCityIds.join(',');
  }

  private patchCityFilterDropdown() {
    const dropdown: any = this.cityFilterDropdown;
    if (!dropdown || dropdown.__cityFilterPatched) {
      this.cityDropdownPatched = !!dropdown;
      return;
    }

    const self = this;
    const originalIsSelected = dropdown.isSelected.bind(dropdown);
    const originalOnItemClick = dropdown.onItemClick.bind(dropdown);

    dropdown.isSelected = function (item) {
      if (self.isAllCitiesSelected) {
        return true;
      }
      if (item && self.citySelectedIdMap[item.id]) {
        return true;
      }
      return originalIsSelected(item);
    };

    const originalNgDoCheck = dropdown.ngDoCheck ? dropdown.ngDoCheck.bind(dropdown) : null;
    dropdown.ngDoCheck = function () {
      if (self.isAllCitiesSelected && this.data && this.data.length > 0) {
        this.isSelectAll = true;
        return;
      }
      if (originalNgDoCheck) {
        originalNgDoCheck();
      }
    };

    dropdown.toggleSelectAll = function () {
      if (!this.isSelectAll && !self.isAllCitiesSelected) {
        self.applyAllCitiesSelection();
      } else {
        self.clearCompactCitySelection();
      }
    };

    dropdown.toggleInfiniteFilterSelectAll = function () {
      const items = this.virtualdata || [];
      if (!this.isInfiniteFilterSelectAll) {
        if (items.length > self.cityBadgeLimit) {
          self.applyLargeCitySelection(items);
          this.isInfiniteFilterSelectAll = true;
          return;
        }
        for (let i = 0; i < items.length; i++) {
          if (!this.isSelected(items[i])) {
            this.addSelected(items[i]);
          }
        }
        this.isInfiniteFilterSelectAll = true;
        self.onFilterSelectAllCity(items);
        return;
      }

      if (self.isAllCitiesSelected || self.isPlaceholderCitySelection(self.selectedCity)) {
        self.clearCompactCitySelection();
        this.isInfiniteFilterSelectAll = false;
        return;
      }
      for (let i = 0; i < items.length; i++) {
        if (this.isSelected(items[i])) {
          this.removeSelected(items[i]);
        }
      }
      this.isInfiniteFilterSelectAll = false;
      self.onFilterDeSelectAllCity(items);
    };

    dropdown.onItemClick = function (item, index, event) {
      if (self.isAllCitiesSelected) {
        if (event) {
          event.stopPropagation();
        }
        return;
      }
      if (self.isPlaceholderCitySelection(self.selectedCity)) {
        self.toggleCompactCitySelection(item);
        if (event) {
          event.stopPropagation();
        }
        return;
      }
      return originalOnItemClick(item, index, event);
    };

    dropdown.__cityFilterPatched = true;
    this.cityDropdownPatched = true;
  }

  private applyAllCitiesSelection() {
    const cityCount = this.dropdownDateCityFilter ? this.dropdownDateCityFilter.length : 0;
    this.citySelectionSeq++;
    this.isApplyingCitySelection = true;
    this.isAllCitiesSelected = cityCount > 0;
    this.isCitySelectionLoading = false;
    this.citySelectedIdMap = {};
    this.listOfCityIds = [];
    this.PageNumber = 1;
    this.PageSize = 10;
    this.selectedCity = cityCount > 0 ? [this.buildAllCitiesPlaceholder(cityCount)] : [];
    this.syncCityDropdownSelection(this.selectedCity, true);
    this.markCitySelectAllChecked();
    setTimeout(() => {
      this.markCitySelectAllChecked();
      this.isApplyingCitySelection = false;
      if (!this.isInActiveRate) {
        this.MainGetAll();
      }
    }, 0);
  }

  private applyLargeCitySelection(items: any[]) {
    items = items || [];
    this.PageNumber = 1;
    this.PageSize = 10;
    if (this.dropdownDateCityFilter && this.dropdownDateCityFilter.length > 0
      && items.length === this.dropdownDateCityFilter.length) {
      this.applyAllCitiesSelection();
      return;
    }

    const seq = ++this.citySelectionSeq;
    this.isAllCitiesSelected = false;
    this.isCitySelectionLoading = true;
    this.isApplyingCitySelection = true;
    this.selectedCity = [this.buildCityCountPlaceholder(items.length)];
    this.syncCityDropdownSelection(this.selectedCity, false);

    this.ngZone.runOutsideAngular(() => {
      const ids = new Array(items.length);
      const selectedIdMap = {};
      for (let i = 0; i < items.length; i++) {
        ids[i] = items[i].id;
        selectedIdMap[items[i].id] = true;
      }
      this.ngZone.run(() => {
        if (seq !== this.citySelectionSeq) {
          this.isApplyingCitySelection = false;
          return;
        }
        this.listOfCityIds = ids;
        this.citySelectedIdMap = selectedIdMap;
        this.selectedCity = [this.buildCityCountPlaceholder(ids.length)];
        this.syncCityDropdownSelection(this.selectedCity, false);
        this.isCitySelectionLoading = false;
        if (!this.isInActiveRate) {
          this.MainGetAll();
        }
        setTimeout(() => {
          this.isApplyingCitySelection = false;
        }, 0);
      });
    });
  }

  private clearCompactCitySelection() {
    this.citySelectionSeq++;
    this.isApplyingCitySelection = true;
    this.isAllCitiesSelected = false;
    this.isCitySelectionLoading = false;
    this.citySelectedIdMap = {};
    this.listOfCityIds = [];
    this.selectedCity = [];
    this.PageNumber = 1;
    this.PageSize = 10;
    this.syncCityDropdownSelection([]);
    if (!this.isInActiveRate) {
      this.MainGetAll();
    } else {
      this.selectedCity = [];
    }
    setTimeout(() => {
      this.isApplyingCitySelection = false;
    }, 0);
  }

  private toggleCompactCitySelection(item: any) {
    if (!item || this.isPlaceholderCityItem(item)) {
      return;
    }
    if (this.citySelectedIdMap[item.id]) {
      delete this.citySelectedIdMap[item.id];
      this.listOfCityIds = this.removeElemetninArray(this.listOfCityIds, item.id);
    } else {
      this.citySelectedIdMap[item.id] = true;
      this.listOfCityIds = this.removeElemetninArray(this.listOfCityIds, item.id);
      this.listOfCityIds.push(item.id);
    }
    this.PageNumber = 1;
    this.PageSize = 10;
    if (this.listOfCityIds.length == 0) {
      this.clearCompactCitySelection();
      return;
    }
    this.selectedCity = [this.buildCityCountPlaceholder(this.listOfCityIds.length)];
    this.syncCityDropdownSelection(this.selectedCity, false);
    if (!this.isInActiveRate) {
      this.MainGetAll();
    }
  }

  private compactSelectedCityIfNeeded() {
    if (!this.selectedCity || this.selectedCity.length <= this.cityBadgeLimit
      || this.isPlaceholderCitySelection(this.selectedCity)) {
      return;
    }
    this.listOfCityIds = this.getIdsFromItems(this.selectedCity);
    this.citySelectedIdMap = {};
    for (let i = 0; i < this.listOfCityIds.length; i++) {
      this.citySelectedIdMap[this.listOfCityIds[i]] = true;
    }
    this.setSelectedCityDisplay(this.selectedCity);
  }

  private setSelectedCityDisplay(selectedItems: any[]) {
    selectedItems = selectedItems || [];
    if (selectedItems.length > this.cityBadgeLimit) {
      this.selectedCity = [this.buildCityCountPlaceholder(selectedItems.length)];
    } else {
      this.selectedCity = selectedItems;
    }
    this.syncCityDropdownSelection(this.selectedCity, this.isAllCitiesSelected);
  }

  private syncCityDropdownSelection(selectedItems: any[], selectAll?: boolean) {
    const dropdown: any = this.cityFilterDropdown;
    if (!dropdown) {
      return;
    }
    dropdown.selectedItems = selectedItems || [];
    dropdown.isSelectAll = !!selectAll || this.isAllCitiesSelected;
    if (typeof dropdown.onChangeCallback === 'function') {
      dropdown.onChangeCallback(dropdown.selectedItems);
    }
    this.markCitySelectAllChecked();
  }

  private markCitySelectAllChecked() {
    const dropdown: any = this.cityFilterDropdown;
    if (!dropdown) {
      return;
    }
    dropdown.isSelectAll = this.isAllCitiesSelected && !!(this.dropdownDateCityFilter && this.dropdownDateCityFilter.length > 0);
  }

  private buildAllCitiesPlaceholder(count: number) {
    return { id: this.allCitiesPlaceholderId, itemName: 'All Cities (' + count + ')' };
  }

  private buildCityCountPlaceholder(count: number) {
    return { id: this.manyCitiesPlaceholderId, itemName: count + ' Cities' };
  }

  private isPlaceholderCitySelection(items: any[]): boolean {
    return !!(items && items.length == 1 && this.isPlaceholderCityItem(items[0]));
  }

  private isPlaceholderCityItem(item: any): boolean {
    return !!(item && (item.id === this.allCitiesPlaceholderId || item.id === this.manyCitiesPlaceholderId));
  }

  private appendSelectedCityItem(item: any): any[] {
    const selectedItems = this.selectedCity ? this.selectedCity.slice() : [];
    for (let i = 0; i < selectedItems.length; i++) {
      if (selectedItems[i] && selectedItems[i].id === item.id) {
        return selectedItems;
      }
    }
    selectedItems.push(item);
    return selectedItems;
  }

  private getIdsFromItems(items: any[]): any[] {
    if (!items || items.length == 0) {
      return [];
    }
    const ids = new Array(items.length);
    for (let i = 0; i < items.length; i++) {
      ids[i] = items[i].id;
    }
    return ids;
  }

  private addIdsFromItems(existingIds: any[], items: any[]): any[] {
    if (!items || items.length == 0) {
      return existingIds || [];
    }
    const idSet = {};
    const result = existingIds ? existingIds.slice() : [];
    for (let i = 0; i < result.length; i++) {
      idSet[result[i]] = true;
    }
    for (let i = 0; i < items.length; i++) {
      const id = items[i].id;
      if (!idSet[id]) {
        idSet[id] = true;
        result.push(id);
      }
    }
    return result;
  }

  private removeIdsFromItems(existingIds: any[], items: any[]): any[] {
    if (!existingIds || existingIds.length == 0) {
      return [];
    }
    if (!items || items.length == 0) {
      return existingIds;
    }
    const removeSet = {};
    for (let i = 0; i < items.length; i++) {
      removeSet[items[i].id] = true;
    }
    const result = [];
    for (let i = 0; i < existingIds.length; i++) {
      if (!removeSet[existingIds[i]]) {
        result.push(existingIds[i]);
      }
    }
    return result;
  }



  openModel(content, rateID) {
    this.rateId = rateID;
    this.modalService.open(content, { centered: true });
  }




  saveLocation() {
    this.isSubmit = true;
    if (this.selectedState.length == 0 || this.selectedItemsCounty.length == 0 || this.selectedCity.length == 0 || this.rateId == 0)
      return
    let location: AddLocation911Model = {
      rateID: this.rateId,
      stateId: this.selectedState[0].id,
      countyId: this.selectedItemsCounty[0].id,
      cityId: this.selectedCity[0].id,
    }
    this.locationService.CreateLocationByRateId(this.tokenKey, location).subscribe(
      result => {
        if (result['status'] == 'Success') {
          if (result['message'] != "") {
            if (result['message'] == "Invalid") this.showMessage('Invalid Data', 'Error', 'error')
            else
              this.showMessage(result['message'], 'Warning', 'warning');
          }
          else {
            this.showMessage('Location Saved Successfully', 'Success', 'success');
            this.modalService.dismissAll();
            this.isSubmit = false;
            this.MainGetAll();
            this.selectedCounty = [];
            this.selectedItemsConuty = [];
            this.selectedState = [];
            this.selectedCity = [];
            this.dropdownDateCountyFilter = [];
            this.dropdownDateCityFilter = [];
          }
        }
        else {
          this.showMessage(result['status'], 'Error', 'error');
        }

      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );

    this.isSubmit = false;

  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  openModelExcel(content) {
    this.modalService.open(content, { centered: true });
  }
  uploadFile() {
    let formData = new FormData();
    formData.append('uploadFile', this.exportDoc)
    this.main911Service.UploadExcel(this.tokenKey, formData).subscribe(result => {
    })
  }
  fileEvent(event): any {
    this.exportDoc = null;
    var file = event.target.files[0];
    this.exportDoc = file;
  }

  contactRate(rateID) {
    window.open('/#/admin/' + this.SelectedTool + '/rates/contact/' + rateID,"_blank");
  }

  setDuplicateId(duplicateRateId) {
    this.duplicateRateId = duplicateRateId;
  }

  duplicateRateData(rateID) {
    sessionStorage.setItem('isDuplicate', 'true');
    window.open('/#/admin/' + this.SelectedTool + '/rates/manage/' + rateID,"_blank");
  }

  onFilterSelectAllState($event){
    this.listOfStateIds = this.addIdsFromItems(this.listOfStateIds, $event);
    this.stateId = this.listOfStateIds.join(',');
    this.GetCountyByStateId(this.stateId);
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
  }

  onFilterDeSelectAllState($event){
    this.listOfStateIds = this.removeIdsFromItems(this.listOfStateIds, $event);
    this.stateId = this.listOfStateIds.join(',');
    this.GetCountyByStateId(this.stateId);
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
  }

  onFilterSelectAllCounty($event){
    this.listOfCountyIds = this.addIdsFromItems(this.listOfCountyIds, $event);
    this.countyId = this.listOfCountyIds.join(',');
    this.GetCityByCountyId(this.countyId);
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
  }

  onFilterDeSelectAllCounty($event){
    this.listOfCountyIds = this.removeIdsFromItems(this.listOfCountyIds, $event);
    this.countyId = this.listOfCountyIds.join(',');
    this.GetCityByCountyId(this.countyId);
    this.PageNumber = 1;
    this.PageSize = 10;
    if (!this.isInActiveRate) this.MainGetAll();
  }

  onFilterSelectAllCity($event){
    this.applyLargeCitySelection($event);
  }

  onFilterDeSelectAllCity($event){
    this.isAllCitiesSelected = false;
    this.listOfCityIds = this.removeIdsFromItems(this.listOfCityIds, $event);
    if ($event) {
      for (let i = 0; i < $event.length; i++) {
        delete this.citySelectedIdMap[$event[i].id];
      }
    }
    this.PageNumber = 1;
    this.PageSize = 10;
    if (this.listOfCityIds.length > this.cityBadgeLimit) {
      this.selectedCity = [this.buildCityCountPlaceholder(this.listOfCityIds.length)];
      this.syncCityDropdownSelection(this.selectedCity, false);
    }
    if (!this.isInActiveRate) this.MainGetAll();
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  onSelectStatus($event) {
    this.listOfStatus = this.removeElemetninArray(this.listOfStatus, $event.id)
    this.listOfStatus.push($event.id);
    this.statusId = '';
    if (this.listOfStatus.length > 0) {
      this.statusId = $event.id;
    }
    this.MainGetAll();
    this.PageNumber = 1;
  }

  onDeSelectStatus($event) {
    if (this.listOfStatus != null) {
      if (this.listOfStatus.length > 0) {
        this.listOfStatus = this.removeElemetninArray(this.listOfStatus, $event.id)
      }
    }
    this.statusId='';
    if (this.listOfStatus.length > 0) {
      this.statusId = $event.id;
    }
    this.MainGetAll();
    this.PageNumber = 1;
  }

 onDeSelectAllStatus($event) {
    this.statusId='';
    this.listOfStatus = [];
    this.MainGetAll();
    this.PageNumber = 1;
  }

}
